<template>
    <svg width="1.125em" height="1.125em" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 15.75L10.5 12.75H16.5V15.75H7.5ZM3 14.25H4.05L11.5875 6.73125L11.0625 6.1875L10.5187 5.6625L3 13.2V14.25ZM1.5 15.75V12.5625L11.5875 2.49375C11.875 2.20625 12.2283 2.0625 12.6473 2.0625C13.0658 2.0625 13.4187 2.20625 13.7062 2.49375L14.7562 3.5625C15.0437 3.85 15.1875 4.2 15.1875 4.6125C15.1875 5.025 15.0437 5.375 14.7562 5.6625L4.6875 15.75H1.5ZM11.5875 6.73125L11.0625 6.1875L10.5187 5.6625L11.5875 6.73125Z" fill="currentColor"/>
    </svg>

</template>
